export let Layout;
(function (Layout) {
  Layout["[band][row][column]"] = "[band][row][column]";
  Layout["[band][row,column]"] = "[band][row,column]";
  Layout["[band,row,column]"] = "[band,row,column]";
  Layout["[row,column,band]"] = "[row,column,band]";
  Layout["[row,column][band]"] = "[row,column][band]";
  Layout["[row][column][band]"] = "[row][column][band]";
  Layout["[row][column,band]"] = "[row][column,band]";
})(Layout || (Layout = {}));